"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DuplicateIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var themes_1 = require("../../themes");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, _c = _a.strokeWidth, strokeWidth = _c === void 0 ? 1 : _c, size = _a.size, rest = __rest(_a, ["fill", "strokeWidth", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 26 26" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M5.5 21.0502H3C1.89543 21.0502 1 20.1548 1 19.0502V3.0502C1 1.94563 1.89543 1.0502 3 1.0502H19C20.1046 1.0502 21 1.94563 21 3.0502V5.5502", stroke: "black", strokeWidth: strokeWidth, fill: fill ? themes_1.THEME.colors.basic.White100 : 'transparent' }, void 0),
            jsx_runtime_1.jsx("rect", { x: "5", y: "5.0502", width: "20", height: "20", rx: "2", stroke: "black", strokeWidth: strokeWidth, fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M15 19.0502V11.0502", stroke: "black", strokeWidth: strokeWidth, strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M19 15.0502L11 15.0502", stroke: "black", strokeWidth: strokeWidth, strokeLinecap: "round" }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, _c = _a.strokeWidth, strokeWidth = _c === void 0 ? 1.5 : _c, size = _a.size, rest = __rest(_a, ["fill", "strokeWidth", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 34 34" }, rest, { children: [jsx_runtime_1.jsx("rect", { x: "6.33331", y: "6.33334", width: "26.6667", height: "26.6667", rx: "2.66667", stroke: "black", strokeWidth: strokeWidth, fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M19.6667 25V14.3333", stroke: "black", strokeWidth: strokeWidth, strokeLinecap: "round", fill: fill ? themes_1.THEME.colors.basic.White100 : 'transparent' }, void 0),
            jsx_runtime_1.jsx("path", { d: "M25 19.6667L14.3333 19.6667", stroke: "black", strokeWidth: strokeWidth, strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M7 27.6667H3.66667C2.19391 27.6667 1 26.4728 1 25V3.66666C1 2.1939 2.19391 1 3.66667 1H25C26.4728 1 27.6667 2.19391 27.6667 3.66667V7", stroke: "black", strokeWidth: strokeWidth }, void 0)] }), void 0));
};
var DuplicateIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.DuplicateIcon = DuplicateIcon;
//# sourceMappingURL=DuplicateIcon.js.map